import { Box, Button, Flex, IconButton, Text } from "@chakra-ui/react"
import React from "react"
import { Suggestion } from "../../../../api-clients/suggest-openapi"
import { CArrowTopLeft } from "../../../shared/Icons"

type Props = {
  suggestions: Array<Suggestion>
  handleClickSuggestion: (e: React.MouseEvent, suggestion: string) => void
  handleUpdateValue: (val: string) => void
  preventBlur: React.MouseEventHandler
}

const TermSuggestions = ({ suggestions, handleClickSuggestion, handleUpdateValue, preventBlur }: Props) => {
  /* Guard clause if no terms suggestions */
  if (!Array.isArray(suggestions) || suggestions.length === 0) return null

  return (
    <Box mt={{ base: "-1", md: "-2" }} mb="3">
      {suggestions.map((sugg) => {
        return (
          <Flex
            align="center"
            justify="space-between"
            key={sugg.searchterm}
            w="100%"
            position="relative"
            mb={{ base: "0", md: "0" }}
          >
            <Button
              variant="secondary"
              color="black"
              width="100%"
              pl="2.5"
              pr="0"
              onMouseDown={preventBlur}
              onClick={(e) => handleClickSuggestion(e, sugg.searchterm)}
              _hover={{ textDecoration: "underline" }}
            >
              <Text fontSize="sm" fontWeight="normal" w="full" textAlign="left">
                {sugg.searchterm}
              </Text>
            </Button>
            <IconButton
              position="absolute"
              top="0"
              right="0"
              aria-label="copy suggestion term"
              icon={<CArrowTopLeft w="4" h="4" />}
              bg="transparent"
              onMouseDown={preventBlur}
              onClick={() => {
                handleUpdateValue(sugg.searchterm)
              }}
            />
          </Flex>
        )
      })}
    </Box>
  )
}

export default TermSuggestions
